const geocodeProviders = {
  POSTCODEIO: 'postcodeio',
  GOOGLEMAPS: 'googlemaps',
};

export default geocodeProviders;
